import API from "utils/API";
import authHeader from "utils/auth-header";
import { ICreateCarnetsRequestParams } from "../domain/ICreateCarnetsRequestParams";
import { IGetCarnetsRequestParams } from "../domain/IGetCarnetsRequestParams";
import { IResponseCarnets } from "../domain/IResponseCarnets";
import { IGetCarnetEmployeesRequestParams } from "../domain/IGetCarnetEmployeesRequestParams";
import { ICarnetEmployee } from "../domain/ICarnetEmployee";
import { IGetCarnetEmployeesResponse } from "../domain/IGetCarnetEmployeesResponse";
import { IDeleteCarnetRequestParams } from "../domain/IDeleteCarnetRequestParams";
import { IMessage } from "domain/IMessage";
import { ICarnet } from "../domain/ICarnet";
import { IUpdateCarnetNoteRequestParams } from "../domain/IUpdateCarnetNoteRequestParamas";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IGetHtzEntriesRequestParams } from "../domain/IGtHtzEntriesRequestParams";
import { IResponseHtz } from "../domain/IResponseHtz";
import { IResponseCarnetPayrolls } from "../domain/IResponseCarnetPayrolls";
import { ICarnetPayrollUpdate } from "../domain/ICarnetPayrollUpdate";
import { ICarnetPayroll } from "../domain/ICarnetPayroll";
import { ICarnetPayrollAddExpense } from "../domain/ICarnetPayrollAddExpense";
import { ICarnetPayrollUpdateExpense } from "../domain/ICarnetPayrollUpdateExpense";
import { IUpdateEmployeeRequestParams } from "../domain/IUpdateEmployeeRequestParams";
import { IResponseCreateCarnets } from "../domain/IResponseCreateCarnets";

const getCarnetEmployees = async (
  params: IGetCarnetEmployeesRequestParams
): Promise<ICarnetEmployee[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetCarnetEmployeesResponse>(
      `/carnets/protected/employee${getQeuryParams(params)}`,
      { headers }
    );
    return response.data.employees;
  } catch (err) {
    throw err;
  }
};

const updateEmployee = async (
  data: IUpdateEmployeeRequestParams
): Promise<ICarnetEmployee> => {
  var headers = authHeader();
  const { employeeId, ...rest } = data;
  try {
    const response = await API.put<ICarnetEmployee>(
      `/carnets/protected/employee/${employeeId}`,
      { ...rest },
      {
        headers,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getCarnetsInPeriod = async (
  params: IGetCarnetsRequestParams
): Promise<IResponseCarnets> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseCarnets>(
      `/carnets/protected/carnet${getQeuryParams(params)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createCarnets = async (
  data: ICreateCarnetsRequestParams
): Promise<IResponseCreateCarnets> => {
  var headers = authHeader();
  try {
    const response = await API.post<IResponseCreateCarnets>(
      "/carnets/protected/carnet",
      data,
      {
        headers,
      }
    );
    let result = response.data;
    return result;
  } catch (err) {
    throw err;
  }
};

const deleteCarnet = async (
  data: IDeleteCarnetRequestParams
): Promise<{ carnetId: number, response: IMessage }> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/carnets/protected/carnet/${data.carnetId}`,
      { headers }
    );
    return {
      carnetId: data.carnetId,
      response: response.data
    };
  } catch (err) {
    throw err;
  }
};

const updateCarnetNote = async (
  data: IUpdateCarnetNoteRequestParams
): Promise<ICarnet> => {
  var headers = authHeader();
  const { carnetId, ...rest } = data;
  try {
    const response = await API.put<ICarnet>(
      `/carnets/protected/carnet/${carnetId}`,
      { ...rest },
      { headers }
    );
    let project = response.data;
    return project;
  } catch (err) {
    throw err;
  }
};

const getHtzEntries = async (
  params: IGetHtzEntriesRequestParams
): Promise<IResponseHtz> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseHtz>(
      `/carnets/protected/htz${getQeuryParams(params)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getPayrollEntries = async (
  employeeId: number
): Promise<IResponseCarnetPayrolls> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseCarnetPayrolls>(
      `/carnets-payroll/protected/payroll${getQeuryParams({ employeeId: employeeId })}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const updateEmployeePayroll = async (
  data: ICarnetPayrollUpdate
): Promise<ICarnetPayroll> => {
  var headers = authHeader();
  const { payrollId, employeeId, ...rest } = data;
  try {
    const response = await API.put<ICarnetPayroll>(
      `/carnets-payroll/protected/payroll/${employeeId}/${payrollId}`,
      { ...rest },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const addExpenseToPayroll = async (
  data: ICarnetPayrollAddExpense
): Promise<ICarnetPayroll> => {
  var headers = authHeader();
  const { payrollId, employeeId, ...rest } = data;
  try {
    const response = await API.post<ICarnetPayroll>(
      `/carnets-payroll/protected/payroll/${employeeId}/${payrollId}`,
      { ...rest },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const updateExpenseInPayroll = async (
  data: ICarnetPayrollUpdateExpense
): Promise<ICarnetPayroll> => {
  var headers = authHeader();
  const { payrollId, employeeId, expenseId, ...rest } = data;
  try {
    const response = await API.put<ICarnetPayroll>(
      `/carnets-payroll/protected/payroll/${employeeId}/${payrollId}/${expenseId}`,
      { ...rest },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export const carnetService = {
  getCarnetEmployees,
  updateEmployee,
  getCarnetsInPeriod,
  getHtzEntries,
  getPayrollEntries,
  updateEmployeePayroll,
  addExpenseToPayroll,
  updateExpenseInPayroll,
  createCarnets,
  deleteCarnet,
  updateCarnetNote,
};
